// Framework and third-party non-UI
import React, { useContext } from 'react';

// Redux, contexts, and local helpers/utils/modules
import { DataGridContext } from './DataGrid';

// Component specific modules (Component-styled, etc.)
import { StyledDataGridHeaderRow } from './DataGrid-styled';

// App components

// Third-party components (buttons, icons, etc.)

const DataGridHeaderRow: React.FC = ({ children }) => {
  const dataGridContext = useContext(DataGridContext);
  return (
    <StyledDataGridHeaderRow {...dataGridContext}>
      {children}
    </StyledDataGridHeaderRow>
  );
};

export default DataGridHeaderRow;
